const ICE = 1;
const MEDIA = 2;

module.exports = {
  ICE,
  MEDIA
};
